//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { Alert } from '@components/atoms/alert/Alert';
import { PrimaryAnchor } from '@components/atoms/anchor/Anchor';
import {
  DM_PERMISSION_SETUP_GUIDE_URL,
  DM_PERMISSION_SETUP_MESSAGE,
  UIA_RIGHTS_FLOW_TRACKING_IDS,
} from '@uia/rights/constants/uiaRightsConstants';
import { useHasInstagramManageMessagesFeatureAndPermissions } from '@uia/rights/hooks/useHasInstagramManageMessagesFeatureAndPermissions';

export const DmRightsRequestConfigInfo = () => {
  const {
    hasInstagramManageMessagesFeatureAndPermissions,
    isFetchingInstagramManageMessagesFeatureAndPermissions,
  } = useHasInstagramManageMessagesFeatureAndPermissions();

  if (
    hasInstagramManageMessagesFeatureAndPermissions ||
    isFetchingInstagramManageMessagesFeatureAndPermissions
  ) {
    return null;
  }

  return (
    <StyledAlert type='warning'>
      {DM_PERMISSION_SETUP_MESSAGE}&nbsp;
      <PrimaryAnchor
        href={DM_PERMISSION_SETUP_GUIDE_URL}
        target='_blank'
        trackingId={UIA_RIGHTS_FLOW_TRACKING_IDS.DM_PERMISSION_SETUP_GUIDE_LINK}
      >
        Setup
      </PrimaryAnchor>
    </StyledAlert>
  );
};

const StyledAlert = styled(Alert)`
  margin-bottom: 0;
`;
